import React from 'react'
import {
  presenceErrorClass,
} from 'servos/formValidations'
import Card from '../../../commons/Card'
import Address from './Address'

class Residential extends React.Component {

  componentDidMount() {
    if (this.props.residentialHistoryIds.length == 0) {
      this.onNewAddressClick()
    }
  }

  componentDidUpdate() {
    if (this.props.residentialHistoryIds.length == 0) {
      this.onNewAddressClick()
    }
  }

  onNewAddressClick = () => {
    let key = Date.now() + parseInt(Math.random()*100);

    this.props.onNewAddressClick({
      key: key,
      data: {
        key,
      }
    })
  }

  render() {
    const {
      errors,
      email,
      mobile,
      handleInput,
      setAddress,
      residentialHistoryIds,
    } = this.props

    return (
      <Card
        iconName='profileHome'
        title='Residential history'
      >
        <div className='card-body'>
          <div className='grey'>
            Please provide at least 3 years of residential history.
          </div>
          <br/>
          { residentialHistoryIds.map((id, index) => {
              return (
                <Address
                  key={id}
                  id={id}
                  onChange={setAddress}
                  allowDestroy={ index !== 0}
                />
              )
            })
          }
          <div className={`invalid-feedback-alert ${presenceErrorClass(errors['residentialHistory'])}`}>
            { errors['residentialHistory'] }
          </div>
          <div className='card card-border card-btn card-add mt-5' onClick={this.onNewAddressClick}>
            <div className='media mt-1 mb-1'>
              <div className='media-body'>
                Add another address
              </div>
              <div className='align-self-center btn-icon'>
                <div className='material-icons'>
                  add_circle_outline
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    )
  }
}

export default Residential;
